<template>
  <div class="pageContent">
    <!-- <p v-if="isError" class="tips">
      <mu-icon value="home"></mu-icon>{{ errMsg }}
      <span class="waiting-time">{{ waitingTime }}</span
      >秒后返回格林首页
    </p> -->
    <p class="tips">
      <mu-icon class="loading-icon" value="cached"></mu-icon>正在跳转中...
    </p>
  </div>
</template>

<script>
import api from "../../api";
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      // isError: false,
      // errMsg: "",
      // waitingTime: 3,
    };
  },
  created() {
    if (this.$route.query.code) {
      this.getLdyInfo(this.$route.query.code);
    } else {
      this.jumpToHome();
    }
  },
  methods: {
    ...mapMutations(["setG_UserInfo"]),
    getLdyInfo(code) {
      let params = new this.URLSearchParam();
      params.append("code", code);

      this.$http
        .post(api.GetLdygoLoginInfo(), params.toParam())
        .then((data) => {
          if (data.Result) {
            this.SaveUserInfo(data.Data);
          } else {
            throw data.Message;
          }
        })
        .catch((msg) => {
          // this.isError = true;
          // this.errMsg = (typeof msg == "string" && msg) || "授权登录失败,";
          // this.waitingToHome();
          console.log(msg);
        })
        .finally(() => {
          // 即使授权失败也不展示提示直接跳回首页
          setTimeout(this.jumpToHome, 10);
        });
    },

    waitingToHome() {
      let timer = setInterval(() => {
        this.waitingTime--;
        if (this.waitingTime <= 0) {
          clearInterval(timer);
          this.jumpToHome();
        }
      }, 1000);
    },
    
    jumpToHome() {
      // 如果想让用户回退时的话依然进入这个页面，可以用push
      this.$router.replace({ path: "/home/index" });
    },

    SaveUserInfo(result) {
      // 保存登录信息
      console.log("-------------");
      var UserInfo = result;
      console.log(result);
      if (UserInfo.Card_Kind_Diplay == "网上数字卡") {
        UserInfo.Card_Kind_Diplay = "数字卡";
      }

      UserInfo.OrderRefresh1 = true;
      UserInfo.OrderRefresh2 = true;
      UserInfo.OrderRefresh3 = true;
      // 保存登录信息
      this.setG_UserInfo(UserInfo);
    },
  },
};
</script>

<style scoped lang="less">
@keyframes loading {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(-360deg);
  }
}
.tips {
  margin-top: 1rem;
  text-align: center;
  font-size: 0.32rem;
  .waiting-time {
    color: #333;
  }
}

.mu-icon {
  margin-right: 0.1rem;
  vertical-align: bottom;
}
.loading-icon {
  animation: loading 2s linear infinite;
}
</style>


// WEBPACK FOOTER //
// ldyBridge.vue?17dc74c7